export enum RefundStatus {
  Processed = 'PROCESSED',
  Finalized = 'FINALIZED',
  Cancelled = 'CANCELLED',
}
